import React, { useState, useEffect } from 'react';
import logo from "../../common/media/cc_logo_white.svg";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import {getMyCCBaseUrlWithMerchantCode} from "../../common/util/pathUtils";
import FlightCalculator from "../../common/components/offset/FlightCalculatorV2";
import { footerLinks } from '../../common/util/uiConfigs/footerConfiguration.js';
import logoGrey from '../../common/media/cc_logo_grey.svg';

const LandingPage = ({ merchantCode }) => {    


    return (
        <>
            <header className="font-default sectionHeader">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="leftLogo">
                                <img src="https://res.cloudinary.com/carbonclick/image/upload/v1661508973/Enterprise/nziba/nziba-logo_sonnlt.svg" style={{height: '109px'}} alt="NZIBA" />
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <section className="font-default bannerSection position-relative img-cover hero-img bg-grey" >
            <a className="carbonLogo" href="https://carbonclick.com" target={"_blank"}><img src="https://res.cloudinary.com/carbonclick/image/upload/v1661318819/Enterprise/nziba/logo2_ed0s8v.svg" /></a>
                <div className="font-default container">
                    <div className="contentCard">
                        <div className="mw-720px">
                            <h1 className="mb-4 mt-0">We've made the New Zealand International Business Awards 2022 climate friendly!</h1>
                            <p className="mb-4">As part of our commitment to sustainability and with the help of CarbonClick, we have calculated the expected emissions of the event and taken actions to reduce it where possible. Any unavoidable emissions remaining have been offset.</p>
                            <p className="mb-4">We're now giving you the opportunity to join our initiative and offset your travel to (hopefully) collect your award!</p>
                            <a href="#scrollCalculator" className="btn btn-primary">Offset my travel</a>
                        </div>
                    </div>
                    <div className="d-flex mt-3 pwdBy">
                        <h4 className="mr-3 mt-0 mb-0">Powered by</h4>
                        <a target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 26 }} src={logoGrey} alt="Carbonclick logo" /></a>
                    </div>
                </div>
            </section>
            
            <section className="font-default climateSection">
                <div className="container text-center">
                    <div className="center mw-600px">
                        <h2 className="font-bold">Expected emissions & actions taken</h2>
                        <p className="m-0">After calculating the expected emissions we are responsible for at the New Zealand International Business Awards 2022, we have firstly taken steps to reduce them and then offset the remainder. This means, we have supported a certified New Zealand climate project that will remove carbon from the atmosphere.</p>
                    </div>
                    <div className="mobile-hide">
                        <div className="center">
                            <div className="row text-align-start m-0">

                                <div className="col-4 d-grid">
                                    <div className="pattern-2 w-100">
                                        <div className="img-cover img-1 w-100">
                                            <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1661318815/Enterprise/nziba/cars-on-road-in-city-during-night-time-3849167_1_nn4ji8.png" alt="6,612 kg of CO2-eq offset" />
                                        </div>
                                        <div className="py-4">
                                            <h3>6,612</h3>
                                            <p>kg of CO2-eq offset </p>
                                            <span>for the New Zealand International Business Awards 2022</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-4 d-grid">
                                    <div className="pattern-2 w-100">
                                        <div className="img-cover img-2 w-100">
                                            <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1661318815/Enterprise/nziba/shane-rounce-DNkoNXQti3c-unsplash_1_cbrggz.png" alt="450 guests" />
                                        </div>
                                        <div className="py-4">
                                            <h3>450</h3>
                                            <p>guests</p>
                                            <span>will enjoy a climate friendly evening</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-4 d-grid">
                                    <div className="pattern-2 w-100">
                                        <div className="img-cover img-3 w-100">
                                            <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1661318815/Enterprise/nziba/autumn-fall-forest-leaves-4700_1_oiii08.png" alt="330 tree growth years" />
                                        </div>
                                        <div className="py-4">
                                            <h3>330</h3>
                                            <p>tree growth years</p>
                                            <span>6,612 kg of carbon is the same amount sequested by 330 average mature trees growing for a year</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mobile-show bg-primary py-3 mt-4 text-center">
                    <Carousel dynamicHeight={false} showThumbs={false} showArrows={false} showStatus={false} infiniteLoop={true} autoPlay={true}>
                        <div key="1" >
                            <div className="pattern-2 w-100">
                                <div className="img-cover img-1 w-100">
                                    <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1661318815/Enterprise/nziba/cars-on-road-in-city-during-night-time-3849167_1_nn4ji8.png" alt="6,612 kg of CO2-eq offset" />
                                </div>
                                <div className="py-4">
                                    <h3>6,612</h3>
                                    <p>kg of CO2-eq offset </p>
                                    <span>for the NZIBA Awards</span>
                                </div>
                            </div>
                        </div>

                        <div key="2">
                            <div className="pattern-2 w-100">
                                <div className="img-cover img-2 w-100">
                                    <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1661318815/Enterprise/nziba/shane-rounce-DNkoNXQti3c-unsplash_1_cbrggz.png" alt="450 guests" />
                                </div>
                                <div className="py-4">
                                    <h3>450</h3>
                                    <p>guests</p>
                                    <span>will enjoy a climate friendly evening</span>
                                </div>
                            </div>
                        </div>
                        <div key="3">
                            <div className="pattern-2 w-100">
                                <div className="img-cover img-3 w-100">
                                    <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1661318815/Enterprise/nziba/autumn-fall-forest-leaves-4700_1_oiii08.png" alt="330 tree growth years" />
                                </div>
                                <div className="py-4">
                                    <h3>330</h3>
                                    <p>tree growth years</p>
                                    <span>6,612 kg of carbon is the same amount sequested by 330 average mature trees growing for a year</span>
                                </div>
                            </div>
                        </div>
                    </Carousel>
                </div>
            </section>
         
            <section className="font-default iconsection">
                <div className="container">
                    <div className="center">
                        <h2>Carbon emissions sources</h2>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-auto col-6">
                            <div className="iconBx oneBx center">
                                <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1661318814/Enterprise/nziba/ico1_pevktn.png" alt="Staff Travel" />
                                <h5>Staff Travel</h5>
                            </div>
                        </div>
                        <div className="col-md-auto col-6">
                            <div className="iconBx twoBx center">
                                <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1661318814/Enterprise/nziba/ico2_m7phe3.svg" alt="Staff Accomodation" />
                                <h5>Staff Accomodation</h5>
                            </div>
                        </div>
                        <div className="col-md-auto col-6">
                            <div className="iconBx threeBx center">
                                <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1661318814/Enterprise/nziba/ico3_jyyr3z.svg" alt="Energy consumption" />
                                <h5>Energy consumption</h5>
                            </div>
                        </div>
                        <div className="col-md-auto col-6">
                            <div className="iconBx fourBx center">
                                <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1661318815/Enterprise/nziba/ico4_oid0sa.svg" alt="Food and Drink" />
                                <h5>Food and Drink</h5>
                            </div>
                        </div>
                    </div>
                    <div className="row bottomBx">
                        <div className="col-md-auto col-6">
                            <div className="iconBx fiveBx center pb-0">
                                <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1661318815/Enterprise/nziba/ico5_dv4oyu.svg" alt="Materials" />
                                <h5>Materials</h5>
                            </div>
                        </div>
                        <div className="col-md-auto">
                            <div className="mainBxImg mt-3">
                                <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1661318816/Enterprise/nziba/iba_iwmpwp.png" alt="Carbon emissions sources" />
                            </div>
                        </div>
                        <div className="col-md-auto col-6">
                            <div className="iconBx sixBx center pb-0">
                                <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1661318816/Enterprise/nziba/ico6_gvl2ns.svg" alt="Waste" />
                                <h5>Waste</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="font-default howWeSection">
                <div className="container">
                    <h2>How we’ve made the New Zealand International Business Awards 2022 more sustainable</h2>
                    <div className="row align-items-center column-reverse">
                        <div className="col-lg-6">
                            <ol>
                                <li>Making pitch sessions virtual, removing the need for judges and applicants to travel to in-person sessions around the country.</li>
                                <li>Partnering with caterers that use locally and responsibly sourced ingredients</li>
                                <li>Reducing the use of printed programmes, menus, and certificates where possible</li>
                                <li>Selecting a venue that is centrally located and close to public transport. Shed 10 is situated in the heart of the Auckland CBD, and close to Britomart Transport Centre.</li>
                                <li>Shed 10, the century-old historic cargo shed on Queens Wharf, has a solar panel system installed on its roof that covers an area of 400sqm. The energy generated powers lighting for the building and is estimated to be equivalent to the annual energy use of ten households.</li>
                            </ol>
                        </div>
                        <div className="col-lg-6">
                            <img src="https://res.cloudinary.com/carbonclick/image/upload/v1661318819/Enterprise/nziba/how_wjp4lb.png" alt="How we’ve made the 2022 NZIBA more sustainable" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="flightSec" id="scrollCalculator">
                <div className="container">
                    <h2 className="center">Join our climate action and offset your travel to the New Zealand International Business Awards 2022!</h2>
                    <div id="FlightCalculatorDummy">
                        <FlightCalculator merchantCode={merchantCode} />
                    </div>
                </div>
            </section>

            <section className="font-default howWeSection btm">
                <div className="container">
                    <h2>Our top-quality, verified carbon offsetting project</h2>
                    <div className="row align-items-center">
                        <div className="col-lg-7">
                            <img className="w-100 mb30" src="https://res.cloudinary.com/carbonclick/image/upload/v1661318820/Enterprise/nziba/our_lvs3cz.png" alt="Our top-quality, verified carbon offsetting project" />
                        </div>
                        <div className="col-lg-5">
                            <h4>Banks Peninsula Forever Forest</h4>
                            <span>Banks Peninsula, Canterbury</span>
                            <p>The Banks Peninsula Forever Forests is a 190 ha property that has been retired from grazing and is being reverted to native forest.</p>
                            <p>Just like the neighbouring Hinewai reserve, natural regeneration will return this land to a vegetation cover similar to that before the forest clearance by human settlers. Hugh Wilson (Botanist & Manager of Hinewai reserve) has provided written support for this project, highlighting the success possible managed under a similar reversion strategy. <a href={`${getMyCCBaseUrlWithMerchantCode(merchantCode)}/projects/BANKS_PENINSULA_FF`} target={"_blank"}>Learn more</a></p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="font-default calculatorSection">
                <div className="container text-center">
                    <div className="mb-4 center">
                        <h2 className="font-bold mb-4 pb-2 mt-0">Curious about your individual carbon footprint?</h2>
                    </div>
                </div>
                <iframe id="PersonalCalculator" className="calculator-iframe  d-flex flex-wrap" src={process.env.MY_CC_URL + '/personal-calculator-embed?merchantCode=BES_US_EARTHSHARE&hideSave=true&hideCookieNotice=true'}></iframe>
            </section>

            <footer className="font-default footerSection" >
                <div className="container color-white">
                    <div className="d-flex">
                        <div>
                            <p className="footerPwd">POWERED BY</p>
                            <a href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">
                                <img style={{ height: 24 }} className="footer-logo" src={logo} alt="carbonclick" />
                            </a>
                        </div>
                        <div className="right">
                            <div>
                                <p className="sml">Previously offset a flight?</p>
                                <p className="sml">Log in to <a href="https://www.carbonclick.com/" target={"_blank"}>My CarbonClick</a> to see the impact</p>
                            </div>
                        </div>
                    </div>
                    <hr className="hrLine" />
                    <div className="row">
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-white bulletPoint" href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">How it works</a></div>
                                <div className="mb-3"><a className="color-white bulletPoint" href={footerLinks?.aboutCarbonClick} target="_blank" rel="noopener noreferrer">About CarbonClick</a></div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-white bulletPoint" href={footerLinks?.termsAndConditions} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></div>
                                <div className="mb-3"><a className="color-white bulletPoint" href={footerLinks?.privacyPolicy} target="_blank" rel="noopener noreferrer">Privacy policy</a></div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-white bulletPoint" href={footerLinks?.contactUs} target="_blank" rel="noopener noreferrer">Contact us</a></div>
                                <div className="mb-3"><a className="color-white bulletPoint" href="mailto:hello+nziba@carbonclick.com" target="_blank" rel="noopener noreferrer">hello@carbonclick.com</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}


export default LandingPage;